"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Ellipsis;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// https://martinwolf.org/blog/2015/01/pure-css-savingloading-dots-animation
function Ellipsis(_ref) {
  var className = _ref.className,
    style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('rrui__ellipsis', className),
    style: style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "rrui__ellipsis__size"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "rrui__ellipsis__dots"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "rrui__ellipsis__dot rrui__ellipsis__dot--1"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "rrui__ellipsis__dot rrui__ellipsis__dot--2"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "rrui__ellipsis__dot rrui__ellipsis__dot--3"
  }))));
}
//# sourceMappingURL=Ellipsis.js.map